import Dropdown from "bootstrap/js/dist/dropdown";
import React, { useState } from "react";
import { Button, Col, Form, Modal, Row, Toast, ToastContainer } from "react-bootstrap";
import { BsFillArrowRightCircleFill, BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { CustomToggleProps } from "../../../../../../core";
import { SubscriptionStrings } from "../../../../../subscription";
import { PaymentOrder, PaymentStrings } from "../../../../business/core";
import { PaymentOrdersFactoryStrategyButtonImpl } from "../../factories";

interface PaymentOrderResponse {
    response: PaymentOrder[]
}

export const PaymentOrdersList: React.FC<PaymentOrderResponse> = ({ response }) => {
    const navigate = useNavigate();
    const strings = PaymentStrings['PTBR'];
    const stringsSubscription = SubscriptionStrings['PTBR'].page.plans;
    const factory = new PaymentOrdersFactoryStrategyButtonImpl();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [toastingText, setToastingText] = useState<string | null>(null);
    const [unsubscribeReason, setUnsubscribeReason] = useState('');

    const handleInputChange = (e) => {
        const text = e.target.value;
        setUnsubscribeReason(text);
    };

    const handlerCancelPlan = async (id: string) => {
        try {
            setLoading(true);
            const controller = new SubscriptionStatementPageControllerImpl();
            const cancelment = await controller.cancelSubscription(id, unsubscribeReason);
            if (!cancelment.success) {
                setToastingText(cancelment.response);
                setLoading(false);
            } else {
                navigate("/");
            }
        } catch (error) {
            setLoading(false);
            setToastingText(error.message);
        }
    }

    const CustomToggle = React.forwardRef<HTMLAnchorElement, CustomToggleProps>(({ children, onClick }, ref) => (
        <a href="/#" ref={ref} onClick={e => { e.preventDefault(); onClick(e); }}>
            <BsThreeDotsVertical />
            {children}
        </a>
    ));

    const CustomStatusIcon = ((expires) => {
        switch (expires) {
            case 0:
                return <span style={{ color: '#2980b9' }}>
                    <BsFillArrowRightCircleFill className="me-2 mb-1" />
                </span>
            case 1:
                return <span style={{ color: 'orange' }}>
                    <BsFillArrowRightCircleFill className="me-2 mb-1" />
                </span>
            default:
                return <span style={{ color: 'red' }}>
                    <BsFillArrowRightCircleFill className="me-2 mb-1" />
                </span>
        }

    })

    return (
        <>
            <ToastContainer>
                <Toast
                    bg={"danger"}
                    onClose={() => setToastingText(null)}
                    show={toastingText !== null ? true : false}
                    delay={5000}
                    autohide
                >
                    <Toast.Body className={"text-white"}>
                        {toastingText !== null ? toastingText : null}
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            <Row style={{ overflow: "hidden" }}>
                <Col>
                    {response.map((subscription, key) => (
                        <Row key={key} className="py-3" style={{ borderBottom: "1px solid #CCCCCC" }}>
                            {subscription.status === 'ACTIVATED' ? (
                                <Col xs={12} className="text-end">
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item href="" onClick={() => setShowModal(true)}>strings.status.ACTIVATED.dropdown?.item1.description</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    <Modal show={showModal} onHide={() => setShowModal(false)}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>strings.status.ACTIVATED.modal_title</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            strings.status.ACTIVATED.modal_description
                                            <Form>
                                                <Form.Group className="mb-3 mt-3" controlId="exampleForm.ControlTextarea1">
                                                    <Form.Label>strings.nps.subscribe_cancelment</Form.Label>
                                                    <Form.Control as="textarea" rows={3} onChange={handleInputChange} />
                                                </Form.Group>
                                            </Form>
                                        </Modal.Body>

                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                                strings.status.ACTIVATED.modal_button_cancel_label
                                            </Button>
                                            <Button variant="primary" onClick={() => handlerCancelPlan(subscription.payment_order_id)} disabled={isLoading}>
                                                strings.status.ACTIVATED.modal_button_confirm_label
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </Col>
                            ) : null}
                            <Col>
                                <p>
                                    <span className="text-capitalize">{CustomStatusIcon(subscription.status)} {subscription.user} {subscription.amount}</span>
                                </p>
                            </Col>
                            <Col>
                                <small>
                                    <p>
                                        {strings.title} {stringsSubscription[subscription.description].title}
                                        <br />
                                        <small>{strings.payment_options[subscription.payment_method].form.title}</small>
                                    </p>
                                </small>
                            </Col >
                            <Col>
                                <small>
                                    <p>
                                        {strings.payment_order.forward_payment_until}<br />
                                        {subscription.expires}
                                    </p>
                                </small>
                            </Col>
                            <Col>
                                {factory.createButton(subscription)}
                            </Col>
                        </Row>
                    ))
                    }
                </Col >
            </Row >
        </>
    );
}
